import { action, makeObservable } from 'mobx';
import { IListOfferingsResponse, IListSponsors } from 'stores/networkInterfaces';
import { parseOfferingResponse } from 'stores/offeringUtils';
import { safeRunRequest } from 'utils/networkRequests';

export const DealSummaryTabs = [
  { path: '', label: 'Summary' },
  { path: 'investment', label: 'Investment' },
  { path: 'asset', label: 'Asset' },
  { path: 'location', label: 'Location' },
  { path: 'sponsor', label: 'Sponsor' }
];

class OfferingStore {
  constructor() {
    makeObservable(this, {
      fetchAssetInfo: action,

      listSponsors: action,
      listInvestorOfferings: action
    });
  }

  handleSponsorListResponse(response: IListSponsors) {
    return response?.data ? response?.data?.map((sponsor) => sponsor.attributes) : [];
  }

  async listSponsors(creatorId?: string[]) {
    const body = { creator_id: creatorId };

    const response = await safeRunRequest('listSponsors', body);
    return this.handleSponsorListResponse(response);
  }

  async listInvestorOfferings(limit = 10, offset = 0) {
    const body = {
      offset,
      limit
    };
    const response = await safeRunRequest('listOfferings', body);

    return { total: response.total, data: this.handleOfferingListResponse(response) };
  }

  handleOfferingListResponse(response: IListOfferingsResponse) {
    return parseOfferingResponse(
      response?.data?.map((item) => item?.attributes).filter((item) => item)
    );
  }

  async fetchAssetInfo(id: string) {
    const body = { id: id };
    const response = await safeRunRequest('offeringInfo', body);

    const {
      data: { attributes: offering }
    } = response;

    return { ...offering, offering_id: offering?.id };
  }
}

export default OfferingStore;
